import React, { useState } from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import Loader from "../../components/Loader";
import api from "../../services/api";
import ReCAPTCHA from "react-google-recaptcha";

const ForgetScreen = ({ location }) => {
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [emailx, setEmailx] = useState("");
  const redirect = location.search ? location.search.split("=")[1] : "/";
  const [isVerified, setIsVerified] = useState(false);

  const submitHandler = async (e) => {
    try {
      setLoading(true);

      e.preventDefault();
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
       // eslint-disable-next-line
       const { data } = await api.post(
        "/api/usersCRC/forget-admin",
        { email: emailx },
        config
      );

      setLoading(false);

      toast.success("Verifique seu e-mail para recuperar o acesso!");

      setTimeout(function () {
        document.location.href = "/adminlogin";
      }, 5500);
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;

      toast.error(err);
    }
  };

  function onChange(value) {
    if (value === null) {
      setIsVerified(false);
    } else {
      setIsVerified(true);
    }
  }

  return (
    <>
      {loading ? (
        <Loader />
      ) : (
        <>
          <ToastContainer />
          <div className='container'>
            <div className='card o-hidden border-0 shadow-lg my-5'>
              <div className='card-body '>
                <div className='row '>
                  <div className='col-lg-5 d-none d-lg-block bg-password-image '></div>
                  <div className='col-lg-7'>
                    <div className='p-5'>
                      <div className='text-center'>
                        <h1 className='h4 text-gray-900 mb-4'>
                        CV SESC ALAGOAS ADMINISTRAÇÃO / Recuperar Acesso 
                        </h1>
                      </div>

                      {/* formulario de cadastro  */}
                      <form className='user' onSubmit={submitHandler}>
                        <div className='form-group'>
                          <input
                            type='email'
                            className='form-control form-control-user'
                            placeholder='Seu e-mail'
                            value={emailx}
                            name='emailx'
                            onChange={(e) => setEmailx(e.target.value)}
                            required
                          />
                        </div>

                        <Button
                          type='submit'
                          className='btn btn-warning btn-user btn-block'
                          disabled={!isVerified}>
                          Recuperar conta
                        </Button>
                      </form>

                      <hr />

                      <div className=' form-group text-center mt-4 ml-5'>
                        <ReCAPTCHA
                          sitekey={process.env.REACT_APP_RECAPTCHA}
                          onChange={onChange}
                        />
                      </div>

                      <div className='text-center mt-5'>
                        <Link
                          to={
                            redirect ? `/adminlogin?redirect=${redirect}` : "/adminlogin"
                          }
                          className='small'>
                          Você já possui conta? Login!
                        </Link>
                      </div>

                      <br />
                      <br />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default ForgetScreen;
